const openAddGroupDialog = ids => ({
  type: 'GROUPS:ADD_GROUP_DIALOG:OPEN',
  ids
})

const closeAddGroupDialog = () => ({
  type: 'GROUPS:ADD_GROUP_DIALOG:CLOSE'
})

export { openAddGroupDialog, closeAddGroupDialog }
